module.exports = __webpack_public_path__ + "svg/safari-pinned-tab.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg/safari-pinned-tab.svg
// module id = 1036
// module chunks = 0